import React, {Component} from 'react';
import {Route, Link, BrowserRouter, Switch} from 'react-router-dom'
import Login from "./pages/Login/Login";
import Routes from './Routes';
import Footer from './Footer';
import NavMenu from "./components/NavMenu";
import TermsModal from "./components/modals/TermsModal";
import AccountMenu from "./components/AccountMenu";
import NotificationList from "./components/NotificationList";
import OmniSearchForm from "./components/OmniSearchForm";
import ShepherdTour from "./components/ShepherdTour";
import './App.css';
import ServerErrorModal from "./modals/ServerErrorModal";
import ActionLink from "./controls/ActionLink";
import PermissionsRequired from "./utils/components/PermissionsRequired";
import RegisterSupplierButton from "./components/RegisterSupplierButton";
import AuthorizationRequired from "./utils/components/AuthorizationRequired";
import {UserContext} from "./auth/Auth";

class App extends Component {
    state = {
        showTermsModal: false,
        showServerErrorModal: false,
        serverError: null
    };

    componentDidCatch(error, info) {
        this.setState({showServerErrorModal: true});
        console.log(error, info);
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/login" component={Login}/>
                    <Route path="/" render={() => {
                        const userContext = UserContext.get();

                        if (userContext && (userContext.shouldAcceptTerms !== this.state.showTermsModal))
                            this.setState({showTermsModal: userContext.shouldAcceptTerms});

                        return (
                            <div>
                                <NavMenu/>
                                <nav className="navbar px-navbar">
                                    <div className="navbar-header">
                                        <Link to="/" className="navbar-brand">
                                            <img src="/assets/img/nav-logo.png" style={{height: '34px', display: 'inline'}}/>
                                        </Link>
                                    </div>
                                    <button type="button" className="navbar-toggle collapsed"
                                            data-toggle="collapse" data-target="#px-demo-navbar-collapse"
                                            aria-expanded="false"><i className="navbar-toggle-icon"/></button>
                                    <ul className="nav navbar-nav">
                                        <AuthorizationRequired>
                                            <OmniSearchForm/>
                                        </AuthorizationRequired>
                                        <PermissionsRequired permissions={[1701]} allowAnonymous={true}>
                                            <RegisterSupplierButton/>
                                        </PermissionsRequired>
                                    </ul>
                                    <div className="collapse navbar-collapse" id="px-demo-navbar-collapse">
                                        <ul className="nav navbar-nav navbar-right">
                                            {/*<NotificationList/>*/}
                                            {/*<li>*/}
                                            {/*<a href="#">*/}
                                            {/*<i className="px-navbar-icon fa fa-comments font-size-14"/>&nbsp;*/}
                                            {/*Поддержка*/}
                                            {/*</a>*/}
                                            {/*</li>*/}
                                            <AccountMenu/>
                                        </ul>
                                    </div>
                                </nav>
                                <Routes/>
                                <Footer/>
                                <TermsModal show={this.state.showTermsModal}
                                            onHide={() => this.setState({showTermsModal: false})}/>
                                <ServerErrorModal error={this.state.serverError}
                                                  show={this.state.showServerErrorModal}
                                                  onHide={() => this.handleServerErrorModalClose()}/>
                                {/*<Route component={ShepherdTour}/>*/}
                            </div>
                        );
                    }}/>
                </Switch>
            </BrowserRouter>
        );
    }

    handleServerErrorModalClose() {
        this.setState({
            showUserEditModal: false
        });
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js